import { AxiosInstance } from 'axios';

import { notificationsEndpoints } from '../../utils/constants';
import { axios } from '../axiosInstance';

import { UpdateNotificationStatus } from './NotificationsApi.schema';

class NotificationsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  updateNotification = async (
    updateNotificationStatus: UpdateNotificationStatus
  ): Promise<void> => {
    return this.#requestInstance.patch(
      notificationsEndpoints.updateNotification(updateNotificationStatus?.id),
      {
        status: updateNotificationStatus?.status,
      }
    );
  };
}

export const notificationsApi = new NotificationsApi(axios);
